export enum CouponValidationErrorMessages {
  CouponNotFound = 'CouponNotFound',
  CouponExpired = 'CouponExpired',
  CouponSoldOut = 'CouponSoldOut',
  LimitedToMedicalConsultation = 'LimitedToMedicalConsultation',
  LimitedToTherapistConsultation = 'LimitedToTherapistConsultation',
  VoucherNotYetValid = 'VoucherNotYetValid',
}
